module.exports = __webpack_public_path__ + "img/reload.860db502.svg";